<template>
  <div class="emergency-page" style="width: calc(100% - 32px); margin: 0 16px">
    <div class="emergency-content">
      <el-form
        label-width="120px"
        :rules="rules"
        :model="form"
        ref="form"
        style="height: 100%"
      >
        <div style="display: flex; justify-content: space-between">
          <el-form-item label="名称" prop="handleProcessName">
            <el-input
              type="text"
              v-model="form.handleProcessName"
              placeholder="请输入流程名称"
              :disabled="type === 3"
            ></el-input>
          </el-form-item>
          <el-form-item label="流程类型" prop="handleProcessType">
            <el-select
              v-model="form.handleProcessType"
              style="width: 100%"
              :disabled="type === 3"
              @change="handleSelectChanges"
            >
              <el-option
                v-for="item in processTypeDic"
                :label="item.label"
                :value="item.value"
                :key="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="子流程类型" prop="subHandleProcessType">
            <el-select
              v-model="form.subHandleProcessType"
              style="width: 100%"
              :disabled="type === 3"
              no-data-text="请先选择流程类型"
            >
              <el-option
                v-for="item in subProcessTypeDic"
                :label="item.label"
                :value="item.value"
                :key="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <div class="dialog-footer">
              <el-button type="info" @click="handleCancel">{{
                type == 3 ? "关闭" : "取消"
              }}</el-button>
              <el-button type="primary" @click="handleSave" v-if="type !== 3"
                >保存</el-button
              >
            </div>
          </el-form-item>
        </div>

        <el-scrollbar style="height: calc(100% - 50px)">
          <el-form-item
            class="editorWrapper"
            prop="handleProcessBase64"
            :error="processError"
          >
            <label style="" class="label-required">现场处置说明</label>
            <editor ref="wEditor" :content="handleProcessBase64" :type="type" />
          </el-form-item>
          <el-form-item
            class="editorWrapper"
            prop="simpleProcessBase64"
            :error="simpleProcessError"
          >
            <label style="" class="label-required">简化流程说明</label>
            <editor
              ref="simpleProcessEditor"
              :content="simpleProcessBase64"
              :type="type"
            />
          </el-form-item>
          <el-form-item label="说明">
            <el-input
              type="textarea"
              v-model="form.desc"
              :rows="5"
              maxlength="200"
              show-word-limit
              :disabled="type === 3"
            ></el-input>
          </el-form-item>
        </el-scrollbar>
      </el-form>
    </div>
  </div>
</template>

<script>
import Editor from "../components/editor";
import api from "../api";
import { Dic } from "$utils";
export default {
  components: { Editor },
  data() {
    return {
      // 处置类型
      processTypeDic: Dic.find("SENU073003"),
      // 子处置类型
      subProcessTypeDic: [],
      handleProcessType: "",
      subHandleProcessType: "",
      processDialogVisiable: false,
      // 处置流程
      handleProcessBase64: "",
      // 简化流程
      simpleProcessBase64: "",
      // 流程名称
      handleProcessName: "",
      // 流程描述
      // 流程错误提示
      processError: "",
      // 简化流程错误提示
      simpleProcessError: "",
      desc: "",
      title: "",
      type: 1,
      form: {
        handleProcessName: "",
        desc: "",
        handleProcessType: "",
        subHandleProcessType: "",
        handleProcessBase64: "",
        simpleProcessBase64: "",
      },
      rules: {
        handleProcessName: [
          {
            required: true,
            message: "流程名称不能为空",
            trigger: "blur",
          },
        ],
        handleProcessType: [
          {
            required: true,
            message: "处置类型不能为空",
          },
        ],
        subHandleProcessType: [
          {
            required: true,
            message: "子处置类型不能为空",
          },
        ],
        // handleProcessBase64: [
        //   {
        //     // required: true,
        //     validator(rule, value, cb) {
        //       if (!value) return cb(new Error('流程不能为空'))
        //     }
        //   }
        // ],
        // simpleProcessBase64: [
        //   {
        //     // required: true,
        //     validator(rule, value, cb) {
        //       if (!value) return cb(new Error('简化流程不能为空'))
        //     }
        //   }
        // ]
      },
    };
  },
  mounted() {
    const query = this.$route.query;
    this.type = parseInt(query.type);
    this.processId = query.id ? query.id : "";
    if (this.type !== 1) {
      this.getDetails();
    }
  },
  watch: {
    processDialogVisiable(newVal) {
      // 清空数据
      if (!newVal) {
        this.handleProcessBase64 = "";
        this.handleProcessName = "";
        this.desc = "";
        this.simpleProcessBase64 = "";
        this.handleProcessType = "";
        this.subHandleProcessType = "";
        this.$refs.wEditor.editor.txt.html("");
        this.$refs.simpleProcessEditor.editor.txt.html("");
      }
    },
    "form.handleProcessType"(newVal) {
      this.handleSelectChange(newVal);
    },
    type(newVal) {
      this.toggleVisible(newVal);
    },
  },
  methods: {
    // 字符串转base64
    encodeBase64(str) {
      const encode = encodeURI(str);
      // 对编码的字符串转化base64
      const base64 = btoa(encode);
      return base64;
    },
    // 解码base64
    decodeBase64(base64) {
      // 对base64转编码
      const decode = atob(base64);
      const str = decodeURI(decode);
      return str;
    },
    handleSelectChanges() {
      this.form.subHandleProcessType = "";
    },
    // 根据流程类型过滤出子流程类型
    handleSelectChange(v) {
      // const subDic = Dic.find("SENU073004");
      this.subProcessTypeDic = Dic.find("SENU0" + (73003000 + v));
      // if (v === 1 || v === 2) {
      //   this.subProcessTypeDic = subDic.filter((item) => item.value === v);
      // } else {
      //   this.subProcessTypeDic = subDic.filter(
      //     (item) => item.value !== 1 && item.value !== 2
      //   );
      // }
    },
    // 前提：type为3为查看详情
    // 查看详情时将富文本设置为disable状态
    toggleVisible(type) {
      // this.processDialogVisiable = true;
      // 查看详情禁用richEditor
      if (type === 3) {
        this.$nextTick(() => {
          this.$refs.wEditor.editor.disable();
          this.$refs.simpleProcessEditor.editor.disable();
        });
      } else {
        // console.log("enable");
        this.$nextTick(() => {
          this.$refs.wEditor.editor.enable();
          this.$refs.simpleProcessEditor.editor.enable();
        });
      }

      this.type = type;
      this.title =
        type === 1
          ? "新增" // this.$t("emergencyHandle.modal.add")
          : type === 2
          ? "修改" // this.$t("emergencyHandle.modal.update")
          : "详情"; // this.$t("emergencyHandle.modal.detail");
    },
    // 编辑/详情时需要流程数据
    async getDetails() {
      try {
        const { success, returnObj } = await this.$fetch(
          api.queryEmergencyHandleProcessDetail,
          {
            handleProcessCode: this.processId,
          }
        );
        if (success) {
          // addProcessInstance.toggleVisible(type);
          this.showDetailData(returnObj);
        }
      } catch (err) {
        console.log(err);
      }
    },
    // 编辑/详情时数据回显
    showDetailData(data) {
      try {
        const {
          handleProcessBase64,
          simpleProcessBase64,
          handleProcessName,
          desc,
          handleProcessCode,
          handleProcessType,
          subHandleProcessType,
        } = data;
        this.$nextTick(() => {
          this.handleProcessBase64 = this.decodeBase64(handleProcessBase64);
          this.simpleProcessBase64 = this.decodeBase64(simpleProcessBase64);
          this.form.handleProcessName = handleProcessName;
          this.form.desc = desc;
          this.handleProcessCode = handleProcessCode;
          this.form.handleProcessType = parseInt(handleProcessType);
          this.form.subHandleProcessType = parseInt(subHandleProcessType);
        });
        // console.log(this.simpleProcessBase64, 'subbb')
      } catch (error) {
        console.error(error);
      }
    },
    // 保存
    async handleSave() {
      const handleProcessBase64 = this.encodeBase64(this.$refs.wEditor.curContent);
      const simpleProcessBase64 = this.encodeBase64(
        this.$refs.simpleProcessEditor.curContent
      );

      if (handleProcessBase64) {
        this.form.handleProcessBase64 = handleProcessBase64;
        this.processError = "";
      } else {
        this.form.handleProcessBase64 = "";
        this.processError = "请填写现场处置说明";
      }
      if (simpleProcessBase64) {
        this.form.simpleProcessBase64 = simpleProcessBase64;
        this.simpleProcessError = "";
      } else {
        this.form.simpleProcessBase64 = "";
        this.simpleProcessError = "请填写简化流程";
      }

      const valid = await this.$refs.form.validate();
      if (!valid) return;
      if (this.processError || this.simpleProcessError) {
        return;
      }
      const params = {
        handleProcessBase64,
        simpleProcessBase64,
        handleProcessType: this.form.handleProcessType + "",
        subHandleProcessType: this.form.subHandleProcessType + "",
        handleProcessName: this.form.handleProcessName,
        desc: this.form.desc,
      };
      if (this.type == 2) {
        params.handleProcessCode = this.handleProcessCode;
      } else {
        delete params.handleProcessCode;
      }
      const realApi =
        this.type === 1
          ? api.addEmergencyHandleProcess
          : api.updateEmergencyHandleProcess;
      try {
        const { success, msgContent } = await this.$fetch(realApi, params);
        if (success) {
          this.$router.push({ path: "/workshop/emergency-handle" });
        } else {
          msgContent && this.$message.warning(msgContent);
        }
      } catch (err) {
        console.error(err);
      }
    },
    // 取消/返回
    handleCancel() {
      this.$router.push("/workshop/emergency-handle");
      // this.processDialogVisiable = false;
      // // 处置流程
      // this.handleProcessBase64 = "";
      // this.simpleProcessBase64 = "";
      // this.handleProcessType = "";
      // this.subHandleProcessType = "";
      // // 流程名称
      // this.handleProcessName = "";
      // // 流程描述
      // this.desc = "";

      // this.$router.go(-1);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@src/common/assets/style/mixin";
.emergency-content {
  padding: 16px;
  @include set_theme_color(background-color, page-bg-color);
  height: 100%;
}
.dialog-footer {
  display: flex;
  justify-content: flex-end;
  // margin-bottom: 15px;
}
.label-required {
  position: absolute;
  left: -105px;
  &::before {
    content: "*";
    color: #f56c6c;
    margin-right: 4px;
  }
}
</style>
